import { FunctionField } from "react-admin";

export const RatingField = (props) => {
  return (
    <FunctionField {...props} render={(record) => `${record?.rating}/5`} />
  );
};
